// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterItem_link__kSzoL","subLink":"FooterItem_subLink__Xn68S"};